const { parse } = JSON
const { warn } = console

export default dump => {
  const { dataset } = dump
  const { content } = dataset
  
  warn(parse(content))
}
